import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/AuthProvider';

const font = "'DM Sans', sans-serif";
const C = { turquesa:'#5dc1b9', mango:'#FDBE02', morado:'#534AB7', moradoClaro:'#AFA9EC' };

const sidebarStyle = { width:240, borderRight:'0.5px solid rgba(255,255,255,0.06)', padding:'14px 10px', background:'rgba(255,255,255,0.012)', display:'flex', flexDirection:'column', fontFamily:font, color:'#fff', overflowY:'auto' };
const secTitleStyle = { margin:'0 8px 8px', fontSize:9, color:'rgba(255,255,255,0.4)', letterSpacing:1.5, textTransform:'uppercase' };
const itemBase = { display:'flex', alignItems:'center', gap:9, padding:'9px 11px', background:'transparent', border:0, color:'rgba(255,255,255,0.75)', fontSize:12, cursor:'pointer', borderRadius:6, transition:'background 0.15s', fontFamily:'inherit', width:'100%', textAlign:'left' };

export default function SidebarEscritorio({ membership, currentView, pensamientosCount = 0, matchesCount = 0 }) {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const tier = membership || 'free_observer';
  const isFree = tier === 'free_observer' || tier === 'tu_radar'; // Tu Radar = Free for matches/permissions; doer and spark_seeker are paid

  const [toast, setToast] = useState(null);
  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 2500); };

  const escritorioPath = tier === 'momentum_builder' ? '/escritorio/momentum' : tier === 'tu_radar' ? '/escritorio/tu-radar' : null;

  const items = [
    { id:'sala', label:'🌐 La Sala', ruta:'/sala' },
    { id:'arbol', label:'🌳 Mi Árbol', ruta:'/arbol' },
    ...(escritorioPath ? [{ id:'escritorio', label:'🔥 Programa 90 días', ruta:escritorioPath }] : []),
    { id:'pensamientos', label:'✏️ Pensamientos atómicos', ruta:'/sala/mi-espacio', badge:pensamientosCount || null },
    { id:'mis-ideas', label:'🧠 Ideas atómicas', ruta:'/mis-ideas' },
    { id:'matches', label:'🎯 Matches', ruta:'/matches', badge: matchesCount || null },
    { id:'conexiones', label:'🤝 Conexiones', ruta:'/conexiones' },
    { id:'newsletter', label:'📧 Newsletter', ruta:'/newsletter', dot:true },
    { id:'conoce', label:'🔭 Conoce proyectos', ruta:'/proyectos' },
  ];

  const [showGenioLuca, setShowGenioLuca] = useState(false);

  const compania = [
    { id:'genio-luca', label:'✨ Genio y Luca', action: () => setShowGenioLuca(prev => !prev) },
    { id:'perfil', label:'👤 Mi perfil', ruta:'/perfil' },
  ];

  const handleClick = (item) => {
    if (item.locked) { showToast('🔒 Disponible desde Doer · $139/mes'); return; }
    if (item.proximamente) { showToast(item.proximamente); return; }
    if (item.action) { item.action(); return; }
    if (item.ruta) navigate(item.ruta);
  };

  const itemStyle = (item) => ({
    ...itemBase,
    background: currentView === item.id ? 'rgba(83,74,183,0.18)' : 'transparent',
    borderLeft: currentView === item.id ? `2px solid ${C.moradoClaro}` : '2px solid transparent',
    borderRadius: currentView === item.id ? '0 6px 6px 0' : 6,
    color: currentView === item.id ? C.moradoClaro : item.locked ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.75)',
    fontWeight: currentView === item.id ? 500 : 400,
    opacity: item.locked ? 0.55 : 1,
    cursor: item.locked ? 'not-allowed' : 'pointer',
  });

  return (
    <aside style={sidebarStyle}>
      <p style={secTitleStyle}>Mi escritorio</p>
      {items.map(item => (
        <button key={item.id} onClick={() => handleClick(item)} style={itemStyle(item)}>
          <span style={{ flex:1 }}>{item.label}</span>
          {item.locked && <span style={{ fontSize:11 }}>🔒</span>}
          {item.dot && <span style={{ width:6, height:6, background:C.mango, borderRadius:'50%' }} />}
          {item.badge && <span style={{ fontSize:9, padding:'1px 6px', borderRadius:999, background:'rgba(93,193,185,0.18)', color:C.turquesa }}>{item.badge}</span>}
        </button>
      ))}

      <div style={{ margin:'14px 0 10px', borderTop:'0.5px solid rgba(255,255,255,0.06)' }} />
      <p style={{ ...secTitleStyle, color:'rgba(253,190,2,0.65)' }}>Compañía</p>
      {compania.map(item => (
        <button key={item.id} onClick={() => handleClick(item)} style={itemStyle(item)}>
          <span style={{ flex:1 }}>{item.label}</span>
        </button>
      ))}

      {showGenioLuca && (
        <div style={{ margin:'6px 4px 0', padding:'14px 12px', background:'rgba(255,255,255,0.04)', border:'0.5px solid rgba(255,255,255,0.08)', borderRadius:10 }}>
          <p style={{ margin:'0 0 6px', fontSize:13, fontWeight:500, color:'#fff' }}>Genio y Luca</p>
          <p style={{ margin:'0 0 4px', fontSize:11, color:'rgba(255,255,255,0.5)', fontStyle:'italic' }}>Tus compañeros de viaje</p>
          <p style={{ margin:'0 0 4px', fontSize:11, color:'rgba(255,255,255,0.6)', lineHeight:1.5 }}>
            <span style={{ color:C.mango }}>⚡ Genio</span> te da chispas creativas.
          </p>
          <p style={{ margin:'0 0 10px', fontSize:11, color:'rgba(255,255,255,0.6)', lineHeight:1.5 }}>
            <span style={{ color:C.turquesa }}>◆ Luca</span> te aterriza con pasos prácticos.
          </p>
          {isFree ? (
            <>
              <p style={{ margin:'0 0 8px', fontSize:10, color:'rgba(255,255,255,0.4)' }}>🔒 Desbloqueados desde Doer $139/mes</p>
              <button onClick={() => navigate('/membresias')} style={{ width:'100%', padding:7, background:'linear-gradient(135deg, #534AB7, #1D9E75)', border:0, color:'#fff', borderRadius:7, fontSize:11, fontWeight:500, cursor:'pointer', fontFamily:'inherit' }}>
                Subir a Doer →
              </button>
            </>
          ) : (
            <p style={{ margin:0, fontSize:10, color:C.turquesa }}>✓ Activos en tu escritorio</p>
          )}
        </div>
      )}

      <div style={{ flex:1 }} />

      {isFree && (
        <div style={{ margin:'14px 4px 0', padding:12, background:'linear-gradient(135deg, rgba(83,74,183,0.2), rgba(29,158,117,0.12))', border:'0.5px solid rgba(175,169,236,0.4)', borderRadius:10 }}>
          <p style={{ margin:'0 0 3px', fontSize:9, color:C.moradoClaro, letterSpacing:1.2, textTransform:'uppercase', fontWeight:500 }}>🚀 Mejora tu plan</p>
          <p style={{ margin:'0 0 9px', fontSize:11, color:'rgba(255,255,255,0.75)', lineHeight:1.5 }}>Desbloquea Mis Ideas + matches contactables + chat libre con Genio y Luca.</p>
          <button onClick={() => navigate('/membresias')} style={{ width:'100%', padding:7, background:'linear-gradient(135deg, #534AB7, #1D9E75)', border:0, color:'#fff', borderRadius:7, fontSize:11, fontWeight:500, cursor:'pointer', fontFamily:'inherit' }}>
            Doer · $139/mes →
          </button>
        </div>
      )}
      <button onClick={async () => { await signOut(); navigate('/'); }} style={{ ...itemBase, color:'rgba(255,255,255,0.4)', fontSize:11, margin:'10px 0 0', gap:7 }}
        onMouseEnter={e => e.currentTarget.style.color='#eb636b'}
        onMouseLeave={e => e.currentTarget.style.color='rgba(255,255,255,0.4)'}
      >
        <span style={{ fontSize:13 }}>↩</span> Cerrar sesion
      </button>
      {toast && (
        <div style={{ position:'fixed', bottom:20, left:'50%', transform:'translateX(-50%)', padding:'10px 18px', background:'rgba(20,20,30,0.95)', border:'0.5px solid rgba(253,190,2,0.3)', borderRadius:10, fontSize:12, color:C.mango, fontFamily:font, zIndex:9999, boxShadow:'0 4px 20px rgba(0,0,0,0.4)', animation:'fadeIn 0.25s ease', whiteSpace:'nowrap', maxWidth:'90vw' }}>
          {toast}
        </div>
      )}
      <style>{`@keyframes fadeIn{from{opacity:0;transform:translate(-50%,8px)}to{opacity:1;transform:translate(-50%,0)}}`}</style>
    </aside>
  );
}
